import { getWebUrl } from "@areahub/config";
import {
  Box,
  chakra,
  Collapse,
  Heading,
  HStack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import * as React from "react";
import { PropsWithChildren } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Link } from "../../../components/link";

export interface CollapsibleStatSectionWrapperProps extends PropsWithChildren {
  title: string;
  subtitle: React.ReactNode;
  knowledgeCenterSlug?: string;
  colorScheme?: string;
}
export const CollapsibleStatsSectionWrapper: React.FC<
  CollapsibleStatSectionWrapperProps
> = ({ children, title, subtitle, knowledgeCenterSlug, colorScheme }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box as="section" pb="10">
      <Box
        bg={`${colorScheme || "blue"}.600`}
        pt="10"
        pb="70px"
        borderRadius="lg"
      >
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          <Box mb="30px" color="white">
            <HStack
              justifyContent="space-between"
              alignItems="center"
              mb="2"
              onClick={onToggle}
              cursor="pointer"
            >
              <Heading
                as="h2"
                size="2xl"
                letterSpacing="tight"
                fontWeight="bold"
                lineHeight="normal"
                id={title.toLowerCase().replace(/\s/g, "-")}
              >
                {title}
              </Heading>
              <Box as={isOpen ? FaChevronUp : FaChevronDown} fontSize="xl" />
            </HStack>
            <Collapse in={isOpen} animateOpacity>
              <chakra.span fontSize="lg" mt="4" fontWeight="medium">
                {subtitle}{" "}
                {knowledgeCenterSlug && (
                  <Link
                    href={`${getWebUrl()}/individuals/knowledge-center/category/${knowledgeCenterSlug}`}
                  >
                    Learn&nbsp;More&nbsp;→
                  </Link>
                )}
              </chakra.span>
              <Text color="white" fontSize="md" my="20px" fontWeight="normal">
                Click on a card to learn more about each hazard and what you can
                do about it.
              </Text>
            </Collapse>
          </Box>
        </Box>
      </Box>
      <Box mt="-20">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
